import React, {Component} from 'react'
import {$$} from '../../../helpers/localization'
import {CONVERTER} from '../../../utils/converter'
import PropTypes from "prop-types";

export default class HeightForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.height ? $$('height_label') : null}<br/>
                <div className="form-group">
                    <div className="input-group mb-3">
                        <input type="number" step="0.01"
                               className={this.props.errors.height ? "custom-error form-control" : "form-control"}
                               value={this.props.height} placeholder={$$('height_label')}
                               name="height" onChange={this.props.onInputChange} required/>
                        <div className="input-group-append">
                            <span className="input-group-text" style={{"height": "auto"}}
                                  id="basic-addon2">{CONVERTER.getUnitByType('HEIGHT')}</span>
                        </div>
                    </div>
                    <div
                        className={this.props.errors.height ? "custom-invalid-feedback" : "invalid-feedback"}>
                        {this.props.errors.height ? $$(this.props.errors.height) : $$('height_required_message')}
                    </div>
                </div>
            </div>
        )
    }
}

HeightForm.propTypes = {
    clearSelectedEntry: PropTypes.func,
    createEntry: PropTypes.func,
    fetchSelectedUserHealthIssues: PropTypes.func,
    formDisabled: PropTypes.object,
    getHealthIssueList: PropTypes.func,
    onInputChange: PropTypes.func,
    errors: PropTypes.any,
    height: PropTypes.any,
    healthIssues: PropTypes.object,
    logbookEntries: PropTypes.array,
    medicalProfile: PropTypes.object,
    onHide: PropTypes.func,
    selectedUser: PropTypes.object,
    settings: PropTypes.object,
    show: PropTypes.bool,
    type: PropTypes.string,
    updateEntry: PropTypes.func,
    updateUserMedicalProfile: PropTypes.func
}